import AdvancedSearch from '@engine/features/payment_transaction/advanced_search';
import EnforceFilters from '@engine/features/payment_trx_enforce_date_range_for_filters';
var PaymentTransaction = {
  EnforceFilters: EnforceFilters,
  AdvancedSearch: AdvancedSearch
};
export default PaymentTransaction;